import { Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ThemeServiceService {
  private activeTheme: string;
  private themeSubject = new BehaviorSubject<string>('');
  public theme$: Observable<string> = this.themeSubject.asObservable();

  constructor(private http: HttpClient) {
    // Get saved theme from localStorage on service initialization
    const savedTheme = localStorage.getItem('theme') || 'viva-light';
    this.activeTheme = savedTheme;
    
    // Apply the saved theme immediately
    this.setTheme(this.activeTheme);
    
    // Initialize the BehaviorSubject
    this.themeSubject.next(this.activeTheme);
    
    // Listen for storage events from other tabs
    window.addEventListener('storage', (event) => {
      if (event.key === 'theme' && event.newValue) {
        // Only update if the theme has actually changed
        if (this.activeTheme !== event.newValue) {
          this.activeTheme = event.newValue;
          this.applyTheme(this.activeTheme);
          this.themeSubject.next(this.activeTheme);
        }
      }
    });
  }

  getTheme(): string {
    return this.activeTheme;
  }

  setTheme(theme: string): void {
    this.activeTheme = theme;
    this.applyTheme(theme);
    
    // Save theme preference to localStorage
    localStorage.setItem('theme', theme);
    
    // Notify subscribers
    this.themeSubject.next(theme);
  }
  
  private applyTheme(theme: string): void {
    let themeLink = document.getElementById('app-theme') as HTMLLinkElement;
    
    if (themeLink) {
      themeLink.href = theme + '.css';
    }
  }
}
